import {arrayUnion} from 'vuex-easy-firestore'
import {mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters('company', ['getScannerConfig']),
        ...mapGetters('jobs', ['getJobsWithWorkflowstates']),
        getScanKey() {
            return this.getScannerConfig.job.key
        }
    },
    methods: {
        async barcodeScanned(barcode) {
            barcode = barcode.replace(/(\r\n|\n|\r)/gm, "").trim()

            let jobInMemory = _.find(this.getJobsWithWorkflowstates, job => {
                return job[this.getScanKey] == barcode
            })
            if (jobInMemory && jobInMemory.length <= 1) {
                if (jobInMemory.finishedDate) {
                    let result = await this.orderFinishedAlready(jobInMemory)
                    if (result.isConfirmed) {
                        return this.$router.push('/start-stop/' + jobInMemory.id)
                    } else {
                        return
                    }
                } else {
                    return this.startStopWorkflow(jobInMemory)
                }
            } else {
                let jobDocs = await this.$FB.collection('jobs').where('companyId', '==', this.getMe.claims.companyId)
                    .where(this.getScanKey, '==', barcode).get()
                let jobs = jobDocs.docs
                if (jobs.length) {
                    jobs = jobs.map(doc => {
                        return {
                            id: doc.id,
                            ...doc.data()
                        }
                    })
                    if (jobs.length == 1) {

                        let job = jobs[0]
                        if (job.finishedDate) {
                            let viewJob =   await this.orderFinishedAlready(job)

                            if (viewJob.isConfirmed) {
                                let routeLink = '/start-stop/' + job.id
                                if (this.$route.path !== routeLink) {
                                    return this.$router.push(routeLink)
                                } else {
                                    return
                                }
                            } else {
                                return
                            }
                        }
                        let activeRuns = _.filter(this.$store.getters['productionRuns/getProductionRunsOfJob'](job.id), run => {
                            return !run.productionEnd && run.workflowId === this.getSelectedWorkflow
                        })


                        if (activeRuns.length) {

                            let states = this.$store.getters['jobs/getJobWorkflowStates'](job.id).filter(state => {
                                return state.id === this.getSelectedWorkflow
                            })
                            // await   this.$store.dispatch('jobs/fetchAndAdd',{where:[['id','==',job.id]]})

                            return this.startStopWorkflow({...job, workflowStates: states})

                        }
                        // let result = await this.$swal({
                        //     title: 'Order found   ' + job[this.getScanKey],
                        //     text: 'Do you want to start this order?',
                        //     showCancelButton: true,
                        //     confirmButtonText: 'Start ' + job[this.getScanKey]
                        // });
                        // if (result.isConfirmed) {
                            await this.startStopWorkflow({...job, workflowStates: []})
                            return this.$router.push('/start-stop/' + job.id)
                        // } else {
                        //     return
                        // }
                    } else if (jobs.length > 1) {


                        var inputOptions = [];

                        jobs.forEach(job => {
                            inputOptions[job.id] =   job.uid +  " | " + job[this.getScanKey];
                        });
                        const {value: jobId} = await this.$swal.fire({
                            title: 'Select field validation',
                            input: 'select',
                            inputOptions: inputOptions,
                            inputPlaceholder: 'Select a ' + this.getScanKey,
                            showCancelButton: true,

                        })

                        if (jobId) {
                            let job = this.getJob(jobId)
                            return this.startStopWorkflow({...job, workflowStates: []})
                        } else {
                            return
                        }

                    }
                    return this.swalToastInfo(this.$t('jobs.noJobsFoundBarcode',[barcode]))
                }
            }
                 return this.swalToastInfo(this.$t('jobs.noJobsFoundBarcode',[barcode]))
        },
        async orderFinishedAlready(order){
         return    await this.$swal({
                title: this.$root.$t('jobs.scanning.jobFinished.title',[ order[this.getScanKey]]) ,
                text: this.$root.$t('jobs.scanning.jobFinished.text'),
                showCancelButton: true,
                confirmButtonText:this.$root.$t('jobs.scanning.jobFinished.confirmButton',[order[this.getScanKey]])
            });
        }
    },
    async beforeDestroy() {
        await this.$barcodeScanner.barCodeEventBus.$off('barcodeScanned', this.barcodeScanned);

    },
    async beforeRouteLeave(from, to, next) {
        await this.$barcodeScanner.barCodeEventBus.$off('barcodeScanned', this.barcodeScanned);
        next();
    },
    async created() {
        this.$barcodeScanner.barCodeEventBus.$on('barcodeScanned', this.barcodeScanned);

    }
}